import React, { useMemo } from 'react'
import { getGenderTypeHotel } from '../bookingUtils';
import { dateFormat, formateDateMonthYear } from '../../../../components/commonClass/CommonValidation';
import { CustomModal } from '../../../../customControl/CustomModal';

const HotelBookingDetailPopup = (props: any) => {
    const { hotelData, show, setShow, activeTab } = props;

    const closeModal = () => {
        setShow(false)
    }

    const passengerData = useMemo(() =>
        hotelData?.getBookingDetailResult?.rooms?.reduce((acc: any, curr: any, index: number, arr: any) => {
            curr?.hotelPassenger?.map((pass: any, index: number) => {
                acc = [...acc, pass]
            })
            return acc;
        }, [])
        , [hotelData])

    const modlabodyfilter = () => {
        return (
            <div className="modal-body px-0 pt-0">
                <div className="label_title">
                    Booking Details
                </div>

                <div className="py-2 px-1">
                    <table className='booking_detail_table w-100 text-center'>
                        <tbody>
                            <tr>
                                <td>
                                    <div className='fw-bold'> ETM Ref. ID </div>
                                </td>
                                <td>
                                    <div className=''> {hotelData?.data?.BookingNo} </div>
                                </td>
                                <td className='p-0' >
                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                </td>
                                <td>
                                    <div className='fw-bold'> Booking ID. </div>
                                </td>
                                <td>
                                    <div className=''> {hotelData?.getBookingDetailResult?.bookingId} </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div className='fw-bold'> Confirmation no. </div>
                                </td>
                                <td>
                                    <div className=''> {hotelData?.getBookingDetailResult?.confirmationNo} </div>
                                </td>
                                <td className='p-0' >
                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                </td>
                                <td>
                                    <div className='fw-bold'> Supplier </div>
                                </td>
                                <td>
                                    <div className=''> TBO </div>
                                </td>
                            </tr>

                            <tr>

                                <td>
                                    <div className='fw-bold'> Hotel Name </div>
                                </td>
                                <td>
                                    <div className=''> {hotelData?.getBookingDetailResult?.hotelDetails?.[0]?.hotelName} </div>
                                </td>
                                <td className='p-0' >
                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                </td>
                                <td>
                                    <div className='fw-bold'> Booking Date </div>
                                </td>
                                <td>
                                    <div className=''> {dateFormat(hotelData?.getBookingDetailResult?.bookingDate)} </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div className='fw-bold'> Check in date </div>
                                </td>
                                <td>
                                    <div className=''>
                                        {formateDateMonthYear(hotelData?.getBookingDetailResult?.checkInDate)}
                                    </div>
                                </td>
                                <td className='p-0' >
                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                </td>
                                <td>
                                    <div className='fw-bold'> Check out date </div>
                                </td>
                                <td>
                                    <div className=''> {formateDateMonthYear(hotelData?.getBookingDetailResult?.checkOutDate)} </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <div className='fw-bold'> Hotel Address </div>
                                </td>
                                <td>
                                    <div className=''>
                                        {hotelData?.getBookingDetailResult?.hotelDetails?.[0]?.address}
                                    </div>
                                </td>
                                <td className='p-0' >
                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                </td>
                                <td>
                                    <div className='fw-bold'> Room Type </div>
                                </td>
                                <td>
                                    <div className=''> {hotelData?.getBookingDetailResult?.rooms?.[0]?.roomTypeName} </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div className="label_title">
                    Pax Details
                </div>

                <div className="py-1 px-1">
                    <div className='overflow-auto'>
                        <table className='Passanger_detail_table w-100 text-center fs_14' style={{ wordBreak: 'break-word' }}>
                            <thead>
                                <tr>
                                    <th>P. No</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th>Contact No.</th>
                                    <th>Email ID</th>
                                    {/* <th>Extra Mattress/Bed</th> */}
                                    <th>Meal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    passengerData?.map((passenger: any, index: any) => {
                                        return (
                                            <tr key={`${passenger?.firstName}${index}`} >
                                                <td style={{ minWidth: '50px' }}> <div> {index + 1} </div> </td>
                                                <td style={{ minWidth: '100px' }}> <div> {passenger?.firstName || "N/A"} </div> </td>
                                                <td style={{ minWidth: '100px' }}> <div> {passenger?.lastName || "N/A"} </div> </td>
                                                <td style={{ minWidth: '80px' }}> <div> {getGenderTypeHotel(passenger?.title) || "N/A"} </div> </td>
                                                <td style={{ minWidth: '50px' }}> <div> {passenger?.age || "N/A"} </div> </td>
                                                <td style={{ minWidth: '110px' }}> <div> {passenger?.phoneno || "N/A"} </div> </td>
                                                <td style={{ minWidth: '150px' }}> <div> {passenger?.email || "N/A"} </div> </td>
                                                {/* <td style={{ minWidth: '150px' }}> <div> {passenger?.extra || "N/A"} </div> </td> */}
                                                <td style={{ minWidth: '150px' }}> <div> N/A </div> </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <>
            <CustomModal
                {...props}
                show={show}
                size='xl'
                onHide={() => setShow(false)}
                modaltitle='Hotel Detail'
                modalbody={modlabodyfilter}
                modalfooter=''
            />
        </>
    )
}

export default HotelBookingDetailPopup
